import angular from 'angular';

export default angular.module('components.ap', [])
    .component('apSimple', {
        template: require('./simple.pug')(),
        controller: ['$state', 'APConfig', function($state, APConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.$state = $state;
                ctrl.catalogid = APConfig.catalogid;
                ctrl.facetsList= APConfig.facetsList;
                ctrl.rsnList= APConfig.rsnList;
                ctrl.schemasList= APConfig.schemasList;
            };
        }]
    })
    .component('apAdvanced', {
        template: require('./advanced.pug')(),
        controller: ['APConfig', function(APConfig) {
            var ctrl = this;
            ctrl.$onInit = function() {
                ctrl.catalogid = APConfig.catalogid;
                ctrl.facetsList= APConfig.facetsList;
                ctrl.rsnList= APConfig.rsnList;
                ctrl.schemasList= APConfig.schemasList;
            };
        }]
    })
    .component('apBrowsing', {
        bindings: {
            start: '<',
            pos: '<'
        },
        template: require('./browsing.pug')(),
        controller: [ 'APConfig', 'ZebraService', '$state', function(APConfig, ZebraService, $state) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = APConfig.catalogid;
                ctrl.index = APConfig.index;
                ctrl.maximumTerms = APConfig.maximumTerms;
                ctrl.callScan(ctrl.start, ctrl.pos);
            };

            ctrl.callScan =  function(term, pos) {
                if (term) {
                    ctrl.loading = true;
                    scan(ctrl.catalogid, ctrl.index, term, pos, ctrl.maximumTerms,  function(err, response) {
                        ctrl.loading = false;
                        if (err) {
                            ctrl.error = err.message || err;
                        }
                        ctrl.response = response;
                        if (ctrl.response && ctrl.response.terms) {
                            var size = ctrl.response.terms.length;
                            if (size > 0) {
                                ctrl.next_term = ctrl.response.terms[size-1].value;
                                ctrl.next_pos = 1;
                            }
                            if (size > 1) {
                                ctrl.prev_term = ctrl.response.terms[0].value;
                                ctrl.prev_pos = size;
                            }
                        }
                    });

                }
            };

            ////////

            function scan(id, index, term, pos, max, done) {
                var params = {};
                params.id = id;
                params.operation = 'scan';
                params.scanClause = index + '="^' + term.replace(/\\"/g, '\\"') +'"';
                params.maximumTerms = max;
                params.responsePosition = pos;
                console.log(params);
                ZebraService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }
        }]
    })
    .component('apSearch', {
        bindings: {
            name: '<'
        },
        template: require('./search.pug')(),
        controller: ['$state', 'ZebraService', 'APConfig', function($state, ZebraService, APConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = APConfig.catalogid;
                ctrl.index = APConfig.index;
                ctrl.schemasList = APConfig.schemasList;
                ctrl.callSearch();
            };

            ctrl.callSearch = function() {
                var query = ctrl.index + '="' + ctrl.name.replace(/"/g, '\\"') + '"';
                var schema = ctrl.schemasList[0].value;

                ctrl.loading = true;
                search(ctrl.catalogid, query, schema, function(err, response) {
                    ctrl.loading = false;
                    if (err) {
                        ctrl.error = err.message || err;
                    }
                    ctrl.response = response;
                });
            };

            ////////

            function search(id, q, schema, done) {
                var params = {};
                params.id = id;
                params.operation = 'search';
                params.query = q;
                params.recordSchema = schema;
                console.log(params);
                ZebraService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }

        }]
    })
    .component('apDocument', {
        bindings: {
            id: '<'
        },
        template: require('./document.pug')(),
        controller: ['$state', 'ZebraService', 'APConfig', function($state, ZebraService, APConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = APConfig.catalogid;
                ctrl.schemasList = APConfig.schemasList;
                ctrl.callSearch();
            };

            ctrl.callSearch = function() {
                var id =  ctrl.id.replace(/"/g, '\\"').replace(/\\/g, '\\\\');
                var query = 'rec.id="' + id + '"';
                var schema = ctrl.schemasList[0].value;

                ctrl.loading = true;
                search(ctrl.catalogid, query, schema, function(err, response) {
                    ctrl.loading = false;
                    if (err) {
                        ctrl.error = err.message || err;
                    }
                    ctrl.response = response;
                });
            };

            ////////

            function search(id, q, schema, done) {
                var params = {};
                params.id = id;
                params.operation = 'search';
                params.query = q;
                params.recordSchema = schema;
                console.log(params);
                ZebraService.get(params).$promise.then(function(response) {
                    done(null, response);
                }, function(err) {
                    done(err, null);
                });
            }

        }]
    })
    .component('apBibliography', {
        bindings: {
            id: '<'
        },
        template: require('./bibliography.pug')(),
        controller: ['APConfig', function(APConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = APConfig.catalogid;
            };
        }]
    })
    .component('apPersonality', {
        bindings: {
            id: '<'
        },
        template: require('./personality.pug')(),
        controller: ['APConfig', function(APConfig) {
            var ctrl = this;

            ctrl.$onInit = function() {
                ctrl.catalogid = APConfig.catalogid;
            };
        }]
    })
    .value('APConfig', {
        type: 'ap',
        catalogid: 5,
        maximumTerms: 20,
        index: "cuba.creatorNormal",
        schemasList: [
            {name: __("BIB"), value: "bib"}, 
            {name: __("BIB v1.1"), value: "bibv1.1"}, 
            {name: __("Portal"), value: "portal"}, 
            {name: __("MARC"), value: "marcxml"} 
        ],
    })
    .name;
